import { render, staticRenderFns } from "./ModalConfirmacaoTermoDesentranhamento.vue?vue&type=template&id=69ba9d35&scoped=true"
import script from "./ModalConfirmacaoTermoDesentranhamento.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacaoTermoDesentranhamento.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmacaoTermoDesentranhamento.vue?vue&type=style&index=0&id=69ba9d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ba9d35",
  null
  
)

export default component.exports